import type { LocationQuery } from 'vue-router'
import type { memberPaymentMethodListNewItem } from '@/api/member'
import { PayMethod, paymentMethodNames } from '@/enums'

export type AddPayMethodRouteConfig = Pick<
  memberPaymentMethodListNewItem,
  'code' | 'name' | 'logo' | 'qr_code_required' | 'fixed'
>

export function buildAddPayMethodRouteQuery(
  item: AddPayMethodRouteConfig,
): Record<string, string> {
  const query: Record<string, string> = {
    type: item.code,
    name: item.name,
    qr_code_required: item.qr_code_required ? '1' : '0',
    fixed: item.fixed ? '1' : '0',
  }
  if (item.logo) query.logo = item.logo
  return query
}

const QR_CODE_PAY_METHODS = new Set<string>([PayMethod.ALIPAYQR, PayMethod.WEPAYQR])

export function parseAddPayMethodRouteQuery(query: LocationQuery): AddPayMethodRouteConfig | null {
  const type = typeof query.type === 'string' ? query.type : ''
  if (!type) return null

  const nameFromQuery = typeof query.name === 'string' ? query.name : ''
  const name =
    nameFromQuery ||
    paymentMethodNames[type as PayMethod] ||
    ''

  if (!name) return null

  const hasQrFlag = query.qr_code_required === '0' || query.qr_code_required === '1'
  const qr_code_required = hasQrFlag
    ? query.qr_code_required === '1'
    : QR_CODE_PAY_METHODS.has(type)

  return {
    code: type,
    name,
    logo: typeof query.logo === 'string' ? query.logo : '',
    qr_code_required,
    fixed: query.fixed === '1',
  }
}
